import React, { memo } from 'react';
import omit from 'lodash/omit';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { BreadcrumbsItem as AkBreadcrumbsItem } from '@atlaskit/breadcrumbs';

const isRegularClick = (e) => !e.metaKey && !e.ctrlKey && e.button === 0;

type BreadcrumbsItemProps = {
	href: string;
	onClick?: (href: string) => void;
	clickEventAnalyticsAttributes: any;
	truncationWidth?: number;
	text: string;
};

export const BreadcrumbsItem = memo((props: BreadcrumbsItemProps) => {
	const { href, onClick, clickEventAnalyticsAttributes } = props;
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const handleClick = (e) => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'breadcrumb',
				source: 'containerNavigation',
				attributes: {
					navVersion: 3,
					...clickEventAnalyticsAttributes,
				},
			},
		}).fire();

		if (onClick && isRegularClick(e)) {
			e.preventDefault();
			onClick(href);
		}
	};

	const akProps = omit(props, ['onClick', 'clickEventAnalyticsAttributes']);

	return <AkBreadcrumbsItem {...akProps} onClick={handleClick} />;
});
